import {
    GET_REVIEW_APPROVAL,
    GET_REVIEW_APPROVAL_FAIL,
    GET_REVIEW_APPROVAL_SUCCESS,
    GET_REVIEW_DETAILS,
    GET_REVIEW_DETAILS_FAIL,
    GET_REVIEW_DETAILS_SUCCESS,
    GET_REVIEW_EXPORT,
    GET_REVIEW_EXPORT_FAIL,
    GET_REVIEW_EXPORT_SUCCESS,
    GET_REVIEW_LISTING,
    GET_REVIEW_LISTING_FAIL,
    GET_REVIEW_LISTING_SUCCESS,
    RESET_REVIEW_DOCUMENT_STATE,
    RESET_REVIEW_STATE,
} from "./actionTypes";

export const getReviewListing = pawn => ({
    type: GET_REVIEW_LISTING,
    payload: pawn,
});

export const getReviewListingSuccess = pawn => ({
    type: GET_REVIEW_LISTING_SUCCESS,
    payload: pawn,
});

export const getReviewListingFail = error => ({
    type: GET_REVIEW_LISTING_FAIL,
    payload: error,
});

export const getReviewDetails = pawn => ({
    type: GET_REVIEW_DETAILS,
    payload: pawn,
});

export const getReviewDetailsSuccess = pawn => ({
    type: GET_REVIEW_DETAILS_SUCCESS,
    payload: pawn,
});

export const getReviewDetailsFail = error => ({
    type: GET_REVIEW_DETAILS_FAIL,
    payload: error,
});

export const getReviewApproval = pawn => ({
    type: GET_REVIEW_APPROVAL,
    payload: pawn,
});

export const getReviewApprovalSuccess = pawn => ({
    type: GET_REVIEW_APPROVAL_SUCCESS,
    payload: pawn,
});

export const getReviewApprovalFail = error => ({
    type: GET_REVIEW_APPROVAL_FAIL,
    payload: error,
});

export const getReviewExport = pawn => ({
    type: GET_REVIEW_EXPORT,
    payload: pawn,
});

export const getReviewExportSuccess = pawn => ({
    type: GET_REVIEW_EXPORT_SUCCESS,
    payload: pawn,
});

export const getReviewExportFail = error => ({
    type: GET_REVIEW_EXPORT_FAIL,
    payload: error,
});

//reset
export const resetReviewState = () => {
    return {
        type: RESET_REVIEW_STATE,
    }
}

export const resetReviewDocumentState = () => {
    return {
        type: RESET_REVIEW_DOCUMENT_STATE,
    }
}

